import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"
import { withTranslation } from "react-i18next"
import MiniCards from "../../components/Common/mini-card"
import { apiBuscarConsultaVendasResumo } from "../../helpers/backend_helper"
import { buildFilters } from "../../helpers/data_helper"
import { describeMoney } from "../../helpers/utils"

const RESUMO_ZERADO = { quantidade_vendas: 0, valor_total: 0, ticket_medio: 0 }

/**
 * Indicadores acima do grid. Consulta o mesmo conjunto de filtros do grid, então os números
 * sempre refletem o que está sendo listado.
 */
const ConsultaVendasResumo = props => {
  const { filters, t } = props

  const [resumo, setResumo] = useState(RESUMO_ZERADO)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!filters) {
      setResumo(RESUMO_ZERADO)
      return
    }

    setLoading(true)
    apiBuscarConsultaVendasResumo({ filters: buildFilters(null, filters, []) })
      .then(resposta => {
        setResumo(resposta || RESUMO_ZERADO)
        setLoading(false)
      })
      .catch(() => {
        setResumo(RESUMO_ZERADO)
        setLoading(false)
      })
  }, [filters])

  return (
    <Row>
      <MiniCards
        title={ t("consultavendas.resumo.quantidade") }
        tooltip={ t("consultavendas.resumo.quantidade.tooltip") }
        iconClass="bx-receipt"
        text={ String(resumo.quantidade_vendas || 0) }
        loading={ loading }
      />
      <MiniCards
        title={ t("consultavendas.resumo.total") }
        tooltip={ t("consultavendas.resumo.total.tooltip") }
        iconClass="bx-dollar-circle"
        text={ describeMoney(resumo.valor_total) }
        loading={ loading }
      />
      <MiniCards
        title={ t("consultavendas.resumo.ticket") }
        tooltip={ t("consultavendas.resumo.ticket.tooltip") }
        iconClass="bx-purchase-tag-alt"
        text={ describeMoney(resumo.ticket_medio) }
        loading={ loading }
      />
    </Row>
  )
}

ConsultaVendasResumo.propTypes = {
  filters: PropTypes.array,
  t: PropTypes.func
}

export default withTranslation()(ConsultaVendasResumo)
